export default __webpack_public_path__ + "static/media/sdm_banner.44ace63f.png";